/**
 * @file getElementSize
 * @author yuzong(yuzong@tencent.com)
 */
import { getDefaultElementSize, isClient } from '@tencent/glue-util-boundary';
/**
 * 获取元素大小
 *
 * @param element 要获取的元素
 */

export function getElementSize(element) {
  if (!isClient()) {
    return getDefaultElementSize();
  }

  return {
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}